import { Button, message, Modal } from "antd";
import { useState } from "react";
import { useUX } from "../contexts/UXContext";
import styles from "./BetaInvite.module.css";

/** Where the user stands, and the first stop on the roadmap they just built. */
const RouteMark = ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className={className}>
        <path d="M4.2 19.2C4.2 12.6 19.8 15.4 19.8 6.4" stroke="currentColor" strokeWidth="1.8"
            strokeLinecap="round" opacity="0.28" />
        <circle cx="4.2" cy="19.2" r="2.4" fill="currentColor" opacity="0.45" />
        <circle cx="19.8" cy="6.4" r="3.6" fill="currentColor" />
    </svg>
);

/**
 * The one screen a non-beta user meets when their roadmap is finished.
 *
 * Both exits cost a single press and neither asks a follow-up: if declining were more
 * expensive than dismissing, we would be teaching people to dismiss.
 *
 * Asked once per user, never per roadmap: declining is not final, so a second roadmap has
 * nothing new to say here. The standing way back in is the Settings switch; the second
 * entry point is the locked journey card on the Dashboard.
 */
const BetaInvite = ({ open, join, onJoined, onDismissed }) => {
    const { refreshUX } = useUX();
    const [joining, setJoining] = useState(false);

    const handleJoin = async () => {
        setJoining(true);
        try {
            await join();
            await refreshUX();
        } catch (err) {
            console.error(err);
            message.error("We couldn't switch beta access on. Please try again.");
            setJoining(false);
            return;
        }
        setJoining(false);
        onJoined();
    };

    return (
        <Modal
            open={open}
            onCancel={onDismissed}
            footer={null}
            title={null}
            // The decline button is the only exit that shows: a close icon beside it would
            // offer the same answer twice, and reads as a hedge on the offer.
            closable={false}
            centered
            width={400}
            classNames={{ content: styles.sheet, mask: styles.mask }}
        >
            <div className={styles.container}>
                <RouteMark className={styles.glyph} />

                <h2 className={styles.headline}>Your first lesson is ready</h2>

                <p className={styles.body}>Switch beta access on to open your roadmap.</p>

                <div className={styles.actions}>
                    <Button
                        type="primary"
                        block
                        loading={joining}
                        onClick={handleJoin}
                        className={styles.accept}
                    >
                        Start learning
                    </Button>
                    <Button block onClick={onDismissed} className={styles.decline}>
                        Not now
                    </Button>
                </div>

                <p className={styles.note}>Free while in beta. Switch off any time in Settings.</p>
            </div>
        </Modal>
    );
};

export default BetaInvite;
